import axios, { AxiosInstance } from 'axios';
import { notify } from '../Utils/toastify';

export let riskBranchId: any = '65b19a912d85aa1743592ac0';

if (`${process.env.mode}` === 'dev') {
  riskBranchId = '65b19a912d85aa1743592ac0';
} else if (`${process.env.mode}` === 'qa') {
  riskBranchId = '65b19a912d85aa1743592ac0';
} else if (`${process.env.mode}` === 'preprod') {
  riskBranchId = '65d167e9aa14894f25f288cf';
}

const axiosInstance: AxiosInstance = axios.create({
  baseURL: `${process.env.API_URL_ONBOARDING}`,
  timeout: 30000,
  headers: {
    api_key: process.env.API_KEY,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    platform: 3,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: 'en',
    offset: new Date().getTimezoneOffset() * 60 * 1000,
  },
});

const clearAuthToken = () => {
  delete axiosInstance.defaults.headers['WWW-Authenticate'];
};

let isLoggingOut = false; // Global flag to track logout execution
const pendingRequests = new Set(); // Store pending API requests

axiosInstance.interceptors.request.use(config => {
  if (isLoggingOut) {
    // Cancel API requests if logout has already started
    const cancelToken = axios.CancelToken.source();
    config.cancelToken = cancelToken.token;
    cancelToken.cancel('Logout in progress, cancelling request');
  } else {
    pendingRequests.add(config); // Track requests
  }

  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  } else {
    config.headers['Authorization'] = `Basic ${btoa(
      `${process.env.API_BASIC_AUTH_CREDENTIALS}`,
    )}`;
  }

  // Check and modify the baseURL for specific endpoints

  if (config.url === 'change-password') {
    config.baseURL = process.env.API_URL_ONBOARDING;
  } else if (process.env.API_URL && config.url === 'studios') {
    config.baseURL = process.env.API_URL.replace('v1/admin', 'v1/common');
  } else if (process.env.API_URL && config.url?.includes('depts')) {
    // Intentionally no baseURL override for depts endpoints.
  }

  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    pendingRequests.delete(response.config); // Remove completed requests
    return response;
  },
  error => {
    pendingRequests.delete(error.config); // Remove failed request

    if (!error.response) return Promise.reject(error); // Handle network errors

    const {
      data: { statusCode, type, message },
    } = error.response;

    if (
      (statusCode === 401 &&
        ['SESSION_EXPIRED', 'Token is not valid.', 'NEW_DEVICE_LOGIN'].includes(
          type,
        )) ||
      message === 'Missing authentication'
    ) {
      if (!isLoggingOut) {
        isLoggingOut = true; // Prevent further execution

        sessionStorage.clear();
        localStorage.clear();

        message !== 'Missing authentication' && notify(message, 'error'); // Show toast only once
        setTimeout(() => {
          localStorage.clear();
          window.location.href = '/login';
        }, 800);
      }

      // eslint-disable-next-line @typescript-eslint/no-empty-function -- intentional: never-resolving promise to stop further execution
      return new Promise(() => {});
    }

    return Promise.reject(error); // Continue rejecting errors
  },
);

export const setAuthorizationToken = (token?: string) => {
  if (token) {
    axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
  }
};
export const resetAuthorizationToken = () => {
  axiosInstance.defaults.headers['Authorization'] = `Basic ${btoa(
    `${process.env.API_BASIC_AUTH_CREDENTIALS}`,
  )}`;
};

const deleteTokenForInstance = () => {
  axiosInstance.interceptors.request.eject(
    axiosInstance.interceptors.request.use((config: any) => config),
  );
};

const axiosInstanceWithoutToken: AxiosInstance = axios.create({
  baseURL: `${process.env.API_URL_ONBOARDING}`,
  timeout: 30000,
  headers: {
    api_key: process.env.API_KEY,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Basic ${btoa(`${process.env.API_BASIC_AUTH_CREDENTIALS}`)}`,
    platform: 3,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: 'en',
    offset: 0,
  },
});

export default {
  axiosInstance,
  setAuthorizationToken,
  clearAuthToken,
  deleteTokenForInstance,
  axiosInstanceWithoutToken,
};
